import { useEffect, useRef } from "react";

/**
 * Simple redirect wrapper — sends the browser to the raw Webflow HTML.
 * Uses history.replaceState + window.location so back-button still works.
 * The URL will change but that's the trade-off for full Webflow theme fidelity.
 */
export default function WebflowPage({ htmlPath }) {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const target = htmlPath + (window.location.search || "");
    window.location.replace(target);
  }, [htmlPath]);
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', -apple-system, sans-serif", color: "#636AC3", fontWeight: 700, background: "#FFFAF0" }}>
      Loading…
    </div>
  );
}
